import { UsersClient } from '@n3oltd/karakoram.users.sdk.users'
import { serviceBaseUrl } from '@/lib/api/baseUrl'
import { createConfig } from '@/lib/api/config'
import { createHttp } from '@/lib/api/http'
import { toSubscriptionCode, type Subscription } from '@/lib/subscription'

interface FetchOptions {
  token: string
  signal?: AbortSignal
}

export async function fetchAvailableSubscriptions({
  token,
  signal,
}: FetchOptions): Promise<Subscription[]> {
  const client = new UsersClient(createConfig(token), serviceBaseUrl('users'), createHttp(signal))
  const response = await client.getSubscriptions()
  const items = response.subscriptions ?? []

  const out: Subscription[] = []
  for (const item of items) {
    if (typeof item.subscriptionId !== 'string' || item.subscriptionId === '') continue
    if (typeof item.subscriptionName !== 'string' || item.subscriptionName === '') continue
    out.push({
      id: item.subscriptionId,
      name: item.subscriptionName,
      code: toSubscriptionCode(item.subscriptionId),
    })
  }
  return out
}
